export default "__VITE_ASSET__DX3jhj8w__"